
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesList from './components/ServicesList';
import ProcessSection from './components/ProcessSection';

const ServicesPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ServicesHero />
        <div data-services-list>
          <ServicesList />
        </div>
        <ProcessSection />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;
